import fetch from '../utils/fetch'

export function getByteMiniCustomPageList (query) {
  return fetch({
    url: '/byte_mini/customizepage/list',
    method: 'get',
    params: query
  })
}
